import { HttpClient } from '@angular/common/http';

import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  GetSessionRedirectStateV1Response,
  GetSessionSummaryResponse,
  UpdatePaymentV1Request,
  UpdateSessionOwnershipV1Request,
  UpdateSessionRedirectStateV1Request,
  UpdateTransactionStatusRequestV1,
  UpdateTransactionStatusResponseV1,
} from '../models';
import { SessionPayment } from '../models/session/session-payment.model';
import { UpdatePayableSessionRequestV1 } from '../models/session/update-payables-session-request-v1.model';
import { SessionService } from './session.service';

/* istanbul ignore next */
export class SessionPlatformService extends SessionService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  updateTransactionStatusV1(
    tenantId: string,
    sessionId: string,
    updateTransactionStatusRequestV1: UpdateTransactionStatusRequestV1,
  ): Observable<UpdateTransactionStatusResponseV1> {
    return this.httpClient.put<UpdateTransactionStatusResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/transaction/status`,
      updateTransactionStatusRequestV1,
    );
  }

  updatePaymentV1(
    tenantId: string,
    sessionId: string,
    updatePaymentRequest: UpdatePaymentV1Request,
  ): Observable<SessionPayment> {
    return this.httpClient.put<SessionPayment>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/payment`,
      updatePaymentRequest,
    );
  }

  getSessionSummaryResponseV1(
    tenantId: string,
    sessionId: string,
  ): Observable<GetSessionSummaryResponse> {
    return this.httpClient.get<GetSessionSummaryResponse>(
      `${this.baseUrl}/v2/tenants/${tenantId}/paymentsessions/${sessionId}/summary`,
    );
  }

  UpdateSessionPayablesSessionV1(
    tenantId: string,
    sessionId: string,
    payload: UpdatePayableSessionRequestV1,
  ): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/payables`,
      payload,
    );
  }

  updateSessionRedirectStateV1(
    tenantId: string,
    sessionId: string,
    payload: UpdateSessionRedirectStateV1Request,
  ): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/redirectstate`,
      payload,
    );
  }

  getSessionRedirectStateV1(
    tenantId: string,
    sessionId: string,
  ): Observable<GetSessionRedirectStateV1Response> {
    return this.httpClient.get<GetSessionRedirectStateV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/redirectstate`,
    );
  }

  updateSessionOwnershipV1(
    tenantId: string,
    sessionId: string,
    payload: UpdateSessionOwnershipV1Request,
  ): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/paymentsessions/${sessionId}/paymentlinks/ownership`,
      payload,
    );
  }
}
